import { Icon24GifLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const GifIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        d="M8.086 9a1.5 1.5 0 0 1 1.06.44l.208.206a.5.5 0 1 1-.708.707l-.207-.207A.5.5 0 0 0 8.086 10H6.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H8a.5.5 0 0 0 .5-.5v-1h-1a.5.5 0 0 1 0-1H9a.5.5 0 0 1 .5.5v1.5A1.5 1.5 0 0 1 8 15H6.5A1.5 1.5 0 0 1 5 13.5v-3A1.5 1.5 0 0 1 6.5 9zM13 9a.5.5 0 0 1 0 1h-.5v4h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1h.5v-4H11a.5.5 0 0 1 0-1zm5.5 0a.5.5 0 0 1 0 1h-3v1.5h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 15 9z"
      />
    </svg>
  );
};

export const GifIcon = fplIcon(GifIconLocal, Icon24GifLarge);
